/** Event id from `/directory/:eventId/...` paths. */
export function eventIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/directory\/([^/]+)/);
  return match?.[1] ?? null;
}

/** Bottom tab bar on Directory / Opportunities / Connections / Me (and event-week Scan / Leads). */
export function showTabBar(pathname: string): boolean {
  if (pathname === "/" || pathname === "/meetup" || /^\/meetup\/[^/]+$/.test(pathname)) {
    return true;
  }
  if (pathname === "/directory" || pathname === "/connections" || pathname === "/me" || pathname === "/me/edit") {
    return true;
  }
  if (pathname === "/opportunities" || pathname === "/opportunities/new") {
    return true;
  }
  if (/^\/me\/projects(?:\/[^/]+)?$/.test(pathname)) {
    return true;
  }
  return /^\/directory\/[^/]+(?:\/(?:connections|edit|scan|leads))?$/.test(pathname);
}

export function isMemberProfilePath(pathname: string): boolean {
  return pathname === "/me" || pathname === "/me/edit" || pathname.startsWith("/me/projects");
}

export type TabId = "meetups" | "directory" | "opportunities" | "scan" | "leads" | "connections" | "me";

export function activeTabFromPath(pathname: string): TabId | null {
  if (pathname === "/" || pathname === "/meetup" || /^\/meetup\/[^/]+$/.test(pathname)) {
    return "meetups";
  }
  if (pathname === "/opportunities" || pathname === "/opportunities/new" || pathname.startsWith("/opportunities/")) {
    return "opportunities";
  }
  if (pathname === "/connections" || /^\/directory\/[^/]+\/connections$/.test(pathname)) {
    return "connections";
  }
  if (
    pathname === "/me" ||
    pathname === "/me/edit" ||
    pathname.startsWith("/me/projects") ||
    /^\/directory\/[^/]+\/edit$/.test(pathname)
  ) {
    return "me";
  }
  if (/^\/directory\/[^/]+\/leads$/.test(pathname)) return "leads";
  if (/^\/directory\/[^/]+\/scan$/.test(pathname)) return "scan";
  if (pathname === "/directory" || /^\/directory\/[^/]+$/.test(pathname)) return "directory";
  return null;
}

export function profileQueryKey(eventId?: string | null): [string, string] {
  return ["profile", eventId || "member"];
}

export function connectionsQueryKey(eventId?: string | null): [string, string] {
  return ["connections", eventId || "all"];
}
